import React, { Component } from 'react';
import Hero from 'components/PageHero/Hero';

export default class AboutItem extends Component {
	render() {
		const videoLink = this.props.videoLink;
		const pictureURL = this.props.pictureURL;
		const channel = this.props.channel;
		return (
			<div className="informationGrid">
				<div className={this.props.informationMedia}>
					<Hero
						imageSrc={pictureURL}
						videoId={videoLink}
						channel={channel}
						showSubtitle
					/>
				</div>
				<div className={this.props.informationContent}>
					<h3 className={this.props.h3className}>{this.props.Title}</h3>
					<p className={this.props.pClassName}>{this.props.children}</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AboutItem/About-Item.jsx